import { initMain } from "./vue/controllers/main";
import { header } from "./vue/controllers/header";
import HScroll from "./vue/components/h-scroll/HScroll.vue";

import { ripeTabsMixin } from "./vue/mixins/ripe-tabs";

import lazyload from "./features/lazy-load";
import proportionalScroll from "./features/proportional-scroll";

lazyload();
proportionalScroll();
const mixins = [];
mixins.push(ripeTabsMixin);

initMain(mixins, {
  HScroll,
  SectionPager: () => import("./vue/components/section-pager/SectionPager.vue"),
  MiniQuoteGraph: () =>
    import("./vue/components/mini-quote-graph/MiniQuoteGraph.vue"),
  TrendsHorizontal: () =>
    import("./vue/components/trends/TrendsHorizontal.vue"),
});
header();
